<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  kicker: { type: String, default: '' },
  // Rota de volta: quando presente, a seta aparece a ESQUERDA do titulo —
  // padrao de navegacao pra toda pagina de detalhe.
  backTo: { type: Object, default: null },
  // Pagina de TABELA/LISTA: aproveita a largura da tela em vez de parar nos
  // 60rem. O padrao continua estreito porque pagina de FORMULARIO com campo
  // esticado de ponta a ponta fica ruim de ler.
  wide: { type: Boolean, default: false },
});

const { t } = useI18n();
const router = useRouter();

// Kicker padrao "Configuracoes" (mesmo padrao visual dos relatorios: micro
// label uppercase na cor da marca acima do titulo).
const kickerLabel = () => props.kicker || t('SIDEBAR.SETTINGS');
</script>

<template>
  <!-- Sem scroll proprio: a pagina rola pelo scroll do SettingsWrapper (a
       barra oficial do painel). Margens negativas cancelam o padding do shell
       pra header/lista irem de borda a borda; o header e sticky contra o
       scroll externo. -->
  <div
    class="flex flex-col w-full -mt-6 sm:-mt-8 -mx-6 -mb-6 sm:-mb-8 lg:-mx-16"
  >
    <header
      class="sticky top-0 z-10 border-b border-n-strong bg-n-surface-1 shrink-0"
    >
      <div
        class="w-full mx-auto px-6"
        :class="wide ? 'max-w-[100rem]' : 'max-w-[60rem]'"
      >
        <div class="flex items-center justify-between pt-6 pb-5">
          <div class="flex items-start gap-3 min-w-0">
            <Button
              v-if="backTo"
              icon="i-lucide-arrow-left"
              variant="ghost"
              color="slate"
              size="sm"
              class="mt-3.5 shrink-0"
              @click="router.push(backTo)"
            />
            <div class="min-w-0">
              <span
                class="block text-[10.5px] font-bold uppercase tracking-[0.09em] text-[#9B2C2C] dark:text-[#F472B6] mb-1"
              >
                {{ kickerLabel() }}
              </span>
              <h1
                class="font-headline text-[22px] font-bold tracking-[-0.015em] leading-[1.15] text-n-slate-12 truncate mb-0"
              >
                {{ title }}
              </h1>
              <!-- Slot pra descricoes ricas (endereco mono + chip de status);
                   o texto simples via prop segue valendo como fallback. -->
              <div
                v-if="description || $slots.description"
                class="text-sm text-n-slate-10 mt-1.5 line-clamp-2"
              >
                <slot name="description">{{ description }}</slot>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2 shrink-0 ml-4">
            <slot name="actions" />
          </div>
        </div>
        <!-- Abas da area (opcional): coladas no header, dentro do sticky -->
        <div v-if="$slots.tabs" class="flex gap-6 -mb-px">
          <slot name="tabs" />
        </div>
      </div>
    </header>
    <main>
      <div
        class="w-full mx-auto px-6 py-6"
        :class="wide ? 'max-w-[100rem]' : 'max-w-[60rem]'"
      >
        <slot />
      </div>
    </main>
  </div>
</template>
